// extracted by mini-css-extract-plugin
export default {"grid":"Skills_grid__Pp+XP","card":"Skills_card__t48Se","iconWrap":"Skills_iconWrap__kbngd","label":"Skills_label__8+wx5"};